import ServiceGraphQL from 'src/service/gql-service';
import { updateInvoice } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateInvoice = (variables) => {
  const params = {
    query: updateInvoice.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
